import { FC } from 'react';

import { useCardOfferDataContext } from 'shared/context/CardContext';

import { CardThumbnails } from './CardThumbnails';

export const CardThumbnailsContainer: FC = () => {
  const {
    media: { thumbnails },
  } = useCardOfferDataContext();

  if (!thumbnails.length) {
    return null;
  }

  return <CardThumbnails items={thumbnails} />;
};
